import React, { Component } from 'react'
import './styles.css'
import cn from 'classnames'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'

const messages = defineMessages({
  secondsPluralized: `{seconds, plural, one {second} other {seconds}}`,
  left: 'left',
  visitTimeLeft: 'Visitation time left'
})

class VisitEndingTimer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      remainingSeconds: 60,
      timerTaskId: null,
      showBubble: true
    }
    this.toggleTimerBubble = this.toggleTimerBubble.bind(this)
  }

  componentDidMount() {
    this.setState({ timerTaskId: setInterval(() => {
      const remainingSeconds = this.state.remainingSeconds
      if (remainingSeconds > 0) {
        this.setState({ remainingSeconds: (remainingSeconds - 1) })
      } else {
        clearInterval(this.state.timerTaskId)
      }
    }, 1000)})
  }

  componentWillUnmount() {
    clearInterval(this.state.timerTaskId)
  }

  toggleTimerBubble() {
    const showBubble = this.state.showBubble
    this.setState({ showBubble: !showBubble })
  }

  render() {
    const {
      remainingSeconds
    } = this.state

    const ticks = []
    for (let i = 1; i <= 60; i++) {
      ticks.push(<div key={i} styleName={cn('tick', { active: i <= (60 - remainingSeconds) })} />)
    }

    return (
      <div styleName='timerWrapper' onClick={this.toggleTimerBubble}>
        <div styleName='ticks'>
          {ticks}
          <div styleName='remainingSeconds'>
            <span styleName='seconds'>{remainingSeconds}</span><br />
            <FormattedMessage {...messages.secondsPluralized} values={{seconds: remainingSeconds}} /><br />
            <FormattedMessage {...messages.left} />
          </div>
        </div>
        <div styleName={cn('timerBubble', { showBubbleText: this.state.showBubble, hideBubbleText: !this.state.showBubble })}>
          <FormattedMessage {...messages.visitTimeLeft} />
        </div>
      </div>
    )
  }



}

VisitEndingTimer.propTypes = {

}

export default VisitEndingTimer
